import { render } from "./TotalCustomer.vue?vue&type=template&id=425b64a8"
import script from "./TotalCustomer.vue?vue&type=script&lang=js"
export * from "./TotalCustomer.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Sistema\\Nueva carpeta\\front-api\\erp-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__